// localStorage key constants — single source of truth
export const GAME_STATE_KEY = "gridlock-game-state";
export const PROGRESS_KEY = "gridlock-progress";
export const RANDOM_PUZZLE_KEY = "gridlock-random-puzzle";
export const ARCHIVE_MONTH_KEY = "gridlock-archive-month";

// Build puzzle key from size and date
export function puzzleKey(size: string, date: string): string {
  return `${size}:${date}`;
}

// Today's date in UTC as YYYY-MM-DD (matches Worker's date handling)
export function getUtcToday(): string {
  return new Date().toISOString().slice(0, 10);
}

// Compute star rating from swaps remaining (0-6)
export function computeStars(swapsRemaining: number): number {
  return swapsRemaining < 0 ? 0 : Math.min(Math.max(swapsRemaining, 0), 6);
}

// Add N days to a YYYY-MM-DD string, returning YYYY-MM-DD
export function addDays(dateStr: string, n: number): string {
  const d = new Date(dateStr + "T00:00:00Z");
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}
